import React from "react"
import { useConsultantDetailsContext } from "../ConsultantDetails"
import { IGetDetailsConsultant } from "../core/_models"
import { useConsultant } from "../../core/useConsultant"
import { useQueryClient } from "react-query"

const ConsultantDetailsActiverEspaceConsultant = () => {
     const queryClient = useQueryClient()
     const { accountEnableDisableEspaceConsultant } = useConsultant()
     const { detailsQuery, REACT_QUERY_KEY_GET_CONSULTANT_DETAILS } = useConsultantDetailsContext()

     const data = detailsQuery.data as IGetDetailsConsultant
     const consultant = data.consultant!

     async function handleEnableDisableEspaceConsultant() {
          const successCallback = () =>
               queryClient.setQueryData<IGetDetailsConsultant | undefined>(REACT_QUERY_KEY_GET_CONSULTANT_DETAILS, (prev: IGetDetailsConsultant | undefined) => {
                    if (prev) {
                         prev.consultant = {
                              ...prev.consultant,
                              candidat: {
                                   ...prev.consultant.candidat,
                                   user: {
                                        ...prev.consultant.candidat?.user,
                                        enabled: !prev.consultant.candidat?.user?.roles?.includes("ROLE_CONSULTANT"),
                                        roles: prev.consultant.candidat?.user?.roles?.includes("ROLE_CONSULTANT") ? ["ROLE_CANDIDAT_EN_COURS_EMBAUCHE"] : ["ROLE_CONSULTANT"],
                                   },
                              },
                         }
                    }

                    return prev
               })

          accountEnableDisableEspaceConsultant(
               consultant,
               () => {},
               () => successCallback()
          )
     }

     return (
          <>
               <div className="alert alert-danger text-gray-700 fw-bold">
                    <div className="fs-5 mb-2 d-flex align-items-center">
                         <i className="fas fa-power-off me-2 text-danger"></i>
                         <span className="text-danger">Activation espace consultant</span>
                    </div>

                    <div>
                         Ce collaborateur a bien été {consultant.contrat === "CONTRAT_ST" ? "intégré" : "embauché"}, mais son espace consultant n’est pas encore activé. Sans cette
                         activation, il ne pourra pas effectuer sa déclaration mensuelle {consultant.contrat === "CONTRAT_ST" && "et joindre sa facture"}.
                         Pour lui donner accès, cliquez sur :
                         <span className="text-primary ms-1 text-pulse cursor-pointer text-hover-dark fw-semibold" onClick={handleEnableDisableEspaceConsultant}>
                              ACTIVER
                         </span>
                    </div>
               </div>
          </>
     )
}

export default ConsultantDetailsActiverEspaceConsultant
